import type { DisclaimerAgreement } from './types';

/**
 * Собирает HTML дисклеймера из элемента свойства AGREEMENT.
 *
 * Заголовок (NAME) оборачивается в <h3> и ставится перед текстом соглашения.
 * Если текста соглашения нет — возвращает пустую строку.
 *
 * @param agreement Элемент PROPERTIES.AGREEMENT.ELEMENT[0]
 * @returns Готовый HTML или пустая строка
 */
export function buildDisclaimerHtml(agreement?: DisclaimerAgreement | null): string {
  const text = agreement?.AGREEMENT_TEXT;
  if (!text?.length) return '';

  const title = agreement?.NAME ? `<h3>${agreement.NAME}</h3>` : '';
  return title + text;
}
